if (!window.Eurus.loadedScript.has('featured-collection.js')) {
  window.Eurus.loadedScript.add('featured-collection.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xFeaturedCollection', (sectionId, pageParam, container, recommendationsUrl = '', productId = '', initialTab = 1) => ({
        sectionId: sectionId,
        pageParam: pageParam,
        currentTab: Number(initialTab) || 1,
        loading: true,
        loaded: [],
        loadingPages: [],
        select(index) {
          this.currentTab = index;
        },
        loadData(index, useRelatedProducts = false) {
          const selectedPage = index - 1;
          if (!this.loaded.includes(selectedPage) && !this.loadingPages.includes(selectedPage)) {
            this.loadingPages.push(selectedPage);
            this.loading = true;

            let url;
            if (useRelatedProducts && recommendationsUrl && productId) {
              const params = new URLSearchParams({
                section_id: this.sectionId,
                product_id: productId,
                limit: '30',
                intent: 'related'
              });
              params.set(this.pageParam, index);
              url = `${recommendationsUrl}?${params.toString()}`;
            } else {
              url = `${window.location.pathname}?section_id=${this.sectionId}&${this.pageParam}=${index}`;
            }

            fetch(url, {
              method: 'GET'
            }).then(
              response => response.text()
            ).then(responseText => {
              const html = (new DOMParser()).parseFromString(responseText, 'text/html');
              const contentId = `x-fc-${this.sectionId}-${index}`;
              const newContent = html.getElementById(contentId);
              const currentContent = document.getElementById(contentId);

              if (useRelatedProducts && newContent && newContent.dataset.featuredCollectionHasProducts !== 'true') {
                const tab = container.querySelector(`[data-featured-collection-tab="${index}"]`);
                tab?.remove();
                currentContent?.remove();

                const remainingTabs = container.querySelectorAll('[data-featured-collection-tab]');

                if (remainingTabs.length === 0) {
                  const sectionElement = document.getElementById(`shopify-section-${this.sectionId}`);
                  const sectionContainer = container.closest('.x-container-featured-collection');
                  if (sectionElement) {
                    sectionElement.hidden = true;
                  } else if (sectionContainer) {
                    sectionContainer.hidden = true;
                  }
                } else {
                  remainingTabs[0].classList.remove('md:border-l', 'pl-2', 'md:pl-4');
                  if (this.currentTab === Number(index)) {
                    this.currentTab = Number(remainingTabs[0].dataset.featuredCollectionTab);
                  }
                  if (remainingTabs.length === 1) {
                    remainingTabs[0].setAttribute('aria-disabled', 'true');
                    const remainingTabLabel = remainingTabs[0].querySelector('[data-featured-collection-tab-label]');
                    if (remainingTabLabel) {
                      remainingTabLabel.classList.remove('cursor-pointer');
                      remainingTabLabel.classList.add('cursor-default');
                    }
                  }
                }

                if (!this.loaded.includes(selectedPage)) {
                  this.loaded.push(selectedPage);
                }
                return;
              }

              if (newContent) {
                if (currentContent && useRelatedProducts) {
                  currentContent.replaceWith(newContent);
                } else if (!currentContent) {
                  container.appendChild(newContent);
                }
                if (!this.loaded.includes(selectedPage)) {
                  this.loaded.push(selectedPage);
                }
              }
            }).catch(error => {
              console.error(error);
            }).finally(() => {
              this.loadingPages = this.loadingPages.filter(page => page !== selectedPage);
              this.loading = this.loadingPages.length > 0;
            })
          }
        },
        scrollIntoView(element) {
          const scrollableContainer = element.closest('.overflow-x-auto'); 
          const elementPosition = element.offsetLeft;

          scrollableContainer.scroll({
            left: elementPosition,
            behavior: 'smooth'
          });
        }
      }));
    });
  });
}
